module.exports = __webpack_public_path__ + "7c375c07284034ab35eaa5a3c5ab38c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Resources/familyActivities/Assets/Food_explorer_passport.png
// module id = 1359
// module chunks = 0